import { useRef, useEffect, useState } from "react";
import "./style.css";
import { detectLanguage, translateText } from "../../../shared/googleTranslateService";

const Input = ({ type, title, min, step, name, className, placeholder, value, defaultValue, required, disabled, options, optionValue, optionLabel, onChange, onChangeData, error, forms, maxLength, pattern, inputMode, ...props }) => {
    // console.log(forms)
    const [inputText, setInputText] = useState('');
    const [translatedText, setTranslatedText] = useState('');

    const quantityInputRef = useRef(null);
    const checkData = (type, step, data) => {
        // console.log(defaultValue, value, type)
        if (type === "number" && step) {
            return parseFloat(data)
        }
        else if (type === "number")
            return parseInt(data)
        else
            return data

    }

    const handleOnChange = (e) => {
        // console.log(defaultValue, value, type, e.target.value)
        onChange(e)
        // onChange(checkData(type, step, e.target.value))
    }

    const handleTranslate = async () => {
        const targetLanguage = 'it'; // Replace with your desired target language code
        const translated = await translateText(inputText, targetLanguage);
        setTranslatedText(translated);
    };

    //   console.log(handleTranslate("Hello Everyone"))
    useEffect(() => {
        const ignoreScroll = (e) => {
            // console.log(e)
            e.preventDefault();
        };
        quantityInputRef.current && quantityInputRef.current.addEventListener("wheel", ignoreScroll);
    }, [quantityInputRef]);

    const onWheel = (e) => {
        e.currentTarget.blur()
        // console.log(e)
    }

    const renderByType = (type) => {
        if (type === "textarea") {
            return (
                <>
                    <textarea
                        type={type}
                        className={`form-control`}
                        placeholder={placeholder}
                        onChange={(e) => handleOnChange(e)}
                        value={value}
                        defaultValue={defaultValue}
                        required={required}
                        disabled={disabled}
                        name={name}
                        style={{ height: 'auto' }}
                        rows={props.rows}
                        {...forms}

                    />
                    {error ? <span>{error}</span> : <span></span>}
                </>
            )
        }
        else if (type === "select") {
            // console.log(options)
            return (
                <>
                    <select
                        type={type}
                        // className={classes.formInput + " " + (classes[className] ? classes[className] : "")}
                        className={`form-control`}
                        defaultValue={defaultValue}
                        onChange={(e) => handleOnChange(e)}
                        value={value}
                        name={name}
                        required={required}
                        disabled={disabled}
                        {...forms}
                    >

                        <option value={""} selected>Select {placeholder}</option>
                        {
                            options && options.map((o, i) => (
                                <option key={i} value={o[optionValue]}>{o[optionLabel]}</option>
                            ))
                        }
                    </select>
                    {error ? <span>{error}</span> : <span></span>}
                </>
            )
        }
        else if (type === "radio") {
            const groupClass = props.radioLayout === "stack"
                ? "ccc-radio-group ccc-radio-group--stack"
                : "ccc-radio-group";

            return (
                <div className={groupClass} style={props.optionStyle}>
                    {options && options.map((p, i) => {
                        const optVal = p[optionValue];
                        const isChecked = optVal === value;
                        const id = `${name}-${i}`;

                        return (
                            <label key={id} className="ccc-radio-option" htmlFor={id}>
                                <input
                                    id={id}
                                    type="radio"
                                    className="ccc-radio-input"
                                    required={required && i === 0}
                                    onChange={e => handleOnChange(e)}
                                    {...forms}
                                    name={name}
                                    disabled={disabled}
                                    value={optVal}
                                    checked={isChecked}
                                />
                                <span className="ccc-radio-pill">{p[optionLabel]}</span>
                            </label>
                        );
                    })}
                </div>
            );
        }
        else {
            return (
                <>
                    <input
                        type={type}
                        min={min}
                        // className={classes.formInput + " " + (classes[className] ? classes[className] : "")}
                        className={`form-control`}
                        placeholder={placeholder}
                        onChange={(e) => handleOnChange(e)}
                        value={value}
                        defaultValue={defaultValue ? defaultValue : ""}
                        required={required}
                        disabled={disabled}
                        step={step}
                        name={name}
                        // autoFocus="autofocus"
                        maxLength={maxLength}
                        pattern={pattern}
                        inputMode={inputMode}
                        style={props.style}
                        onWheel={(e) => onWheel(e)}
                        {...forms}
                    />
                    {error ? <span>{error}</span> : (props.hideError ? "" : <span></span>)}
                    {
                        props.showEye && <i class={`fa fa-eye`} onClick={() => props.setEye(!props.eye)} aria-hidden="true"></i>
                    }


                </>
            )
        }
    }

    const handleChangeCheck = (e) => {
        if (e.target.checked) {
            onChange("Yes")
        }
        else {
            onChange("No")
        }

    }

    return (
        <>
            {
                type === "checkbox"
                    ?
                    <>
                        <div>
                            <input
                                type="checkbox"
                                // className={classes.checkbox}
                                className={`fancy-radio`}
                                required={required}
                                onChange={e => handleChangeCheck(e)}
                                checked={value === "Yes" ? true : false}
                                disabled={disabled}
                            />
                            <span style={{ textAlign: 'left' }}>{title}</span>
                        </div>
                        {error ? <span>{error}</span> : null}
                    </>
                    :
                    <div className="ccc-field" style={props.sectionStyle}>
                        {title ? (
                            <label
                                className={`ccc-field-label${type === "radio" ? " ccc-field-label--inline" : ""}`}
                                style={props.labelStyle}
                            >
                                {title}
                            </label>
                        ) : null}
                        {renderByType(type)}
                    </div>
            }
        </>

    )
}

export default Input;